import { render } from "./SuccessStory.vue?vue&type=template&id=11354cd8"
import script from "./SuccessStory.vue?vue&type=script&lang=js"
export * from "./SuccessStory.vue?vue&type=script&lang=js"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__